// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__a7rOY","headline":"styles_headline__dQ_G9","label":"styles_label__zrBSb","tip":"styles_tip__dl_dx","group":"styles_group__7jD4m"};